export const CUSTOM_QUERY_CATEGORY_LIST = 'CUSTOM_QUERY_CATEGORY_LIST';
export const CUSTOM_QUERY_CATEGORY_LOADING = 'CUSTOM_QUERY_CATEGORY_LOADING';
export const CUSTOM_QUERY_CATEGORY_LIST_ERROR =
  'CUSTOM_QUERY_CATEGORY_LIST_ERROR';
export const CUSTOM_QUERY_DATA_LOADING = 'CUSTOM_QUERY_DATA_LOADING';
export const CUSTOM_QUERY_DATA_LIST = 'CUSTOM_QUERY_DATA_LIST';
export const CUSTOM_QUERY_DATA_ERROR = 'CUSTOM_QUERY_DATA_ERROR';
export const CLEAR_QUERY_ERROR = 'CLEAR_QUERY_ERROR';
export const CATEGORY_SAVE_SUCCESS = 'CATEGORY_SAVE_SUCCESS';
export const CUSTOM_QUERY_SAVE_ERROR = 'CUSTOM_QUERY_SAVE_ERROR';
export const CUSTOM_QUERY_DOWNLOAD_ERROR = 'CUSTOM_QUERY_DOWNLOAD_ERROR';
export const CUSTOM_QUERY_EXECUTE_ERROR = 'CUSTOM_QUERY_EXECUTE_ERROR';
export const CUSTOM_QUERY_EXECUTE_SUCCESS = 'CUSTOM_QUERY_EXECUTE_SUCCESS';
export const CATEGORY_SAVE_ERROR = 'CATEGORY_SAVE_ERROR';
export const CATEGORY_DELETE_ERROR = 'CATEGORY_DELETE_ERROR';
export const CUSTOM_QUERY_DELETE_ERROR = 'CUSTOM_QUERY_DELETE_ERROR';
export const CUSTOM_QUERY_DELETE_SUCCESS = 'CUSTOM_QUERY_DELETE_SUCCESS';
export const CUSTOM_QUERY_CATEGORY_DELETE_SUCCESS =
  'CUSTOM_QUERY_CATEGORY_DELETE_SUCCESS';
export const CUSTOM_QUERY_SAVE_SUCCESS = 'CUSTOM_QUERY_SAVE_SUCCESS';
export const CUSTOM_QUERY_SET_NEW_CATEGORY = 'CUSTOM_QUERY_SET_NEW_CATEGORY';



// WEBPACK FOOTER //
// ./src/pages/utilities/state/customQueries/types.js